

import React, { useState, useEffect } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import axios from '../api/axios';
import "./CemeteryMap.css";

const MapasTable = () => {
  const [occupiedGraves, setOccupiedGraves] = useState([]);
  const [groupedGraves, setGroupedGraves] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    axios.get("/sepulturasc")
      .then((response) => {
        const data = response.data;
        const grouped = data.reduce((acc, sepultura) => {
          const { lugareId, id, clausurado, ocupado } = sepultura;
          if (!acc[lugareId]) {
            acc[lugareId] = [];
          }
          acc[lugareId].push({ id, clausurado, ocupado });
          return acc;
        }, {});
  
        const groupedArray = Object.keys(grouped).map(lugareId => ({
          lugareId,
          graves: grouped[lugareId]
        }));
  
        groupedArray.sort((a, b) => a.lugareId - b.lugareId);
        setGroupedGraves(groupedArray);
      })
      .catch((error) => console.error("Error fetching sepulturas:", error));
  }, []);

/*  
  useEffect(() => {
    fetch("/sepulturasc")
      .then((response) => response.json())
      .then((data) => {
        const grouped = data.reduce((acc, sepultura) => {
          const { lugareId, id, clausurado, ocupado } = sepultura;
          if (!acc[lugareId]) {
            acc[lugareId] = [];
          }
          acc[lugareId].push({ id, clausurado, ocupado });
          return acc;
        }, {});

        const groupedArray = Object.keys(grouped).map(lugareId => ({
          lugareId,
          graves: grouped[lugareId]
        }));

        groupedArray.sort((a, b) => a.lugareId - b.lugareId);
        setGroupedGraves(groupedArray);
      })
      .catch((error) => console.error("Error fetching sepulturas:", error));
  }, []);
*/
  const totalPages = groupedGraves.length;
  const currentLugar = groupedGraves[currentPage];

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (index) => {
    setCurrentPage(index);
  };

  if (totalPages === 0) {
    return <div>No hay sepulturas disponibles.</div>;
  }

  return (
    <div className="cemetery-container">
      <h1 className="title">Plano Cementerio</h1>
      {currentLugar && (
        <>
          <div className="cemetery-grid">
            {currentLugar.graves.map((grave) => (
              <div
                key={grave.id}
                className={`grave ${Number(grave.clausurado) === 1 ? "clausurado" : Number(grave.ocupado) === 0 ? "available" : "occupied"}`}
              >
                {grave.id}
              </div>
            ))}
          </div>

          <div className="pagination-controls">
            <button
              className="pagination-btn"
              onClick={handlePrevPage}
              disabled={currentPage === 0}
            >
              <FaAngleLeft />
            </button>

            <div className="page-buttons">
              {groupedGraves.map((group, index) => (
                <button
                  key={index}
                  className={`page-btn ${index === currentPage ? "active" : ""}`}
                  onClick={() => handlePageClick(index)}
                >
                  {group.lugareId} 
                </button>
              ))}
            </div>

            <button
              className="pagination-btn"
              onClick={handleNextPage}
              disabled={currentPage === totalPages - 1}
            >
              <FaAngleRight />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MapasTable;



/*
import React, { useState, useEffect } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import axios from '../api/axios';
import "./CemeteryMap.css";

const MapasTable = () => {
  const [occupiedGraves, setOccupiedGraves] = useState([]);
  const [groupedGraves, setGroupedGraves] = useState([]);
  const [currentPage, setCurrentPage] = useState(0); // Página actual como índice de lugarId

  useEffect(() => {
    fetch("/sepulturasc")
      .then((response) => response.json())
      .then((data) => {
        // Agrupar las sepulturas por lugarId
        const grouped = data.reduce((acc, sepultura) => {
          const { lugareId, id } = sepultura;
          if (!acc[lugareId]) {
            acc[lugareId] = [];
          }
          acc[lugareId].push(id);
          return acc;
        }, {});

        // Convertir a un array de lugares ordenados
        const groupedArray = Object.keys(grouped).map(lugareId => ({
          lugareId,
          graves: grouped[lugareId]
        }));

        // Ordenamos los lugares por lugarId
        groupedArray.sort((a, b) => a.lugareId - b.lugareId);

        setGroupedGraves(groupedArray);
      })
      .catch((error) => console.error("Error fetching sepulturas:", error));
  }, []);

  const totalPages = groupedGraves.length;
  const currentLugar = groupedGraves[currentPage];

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (index) => {
    setCurrentPage(index);
  };

  // Verifica si hay datos para mostrar
  if (totalPages === 0) {
    return <div>No hay sepulturas disponibles</div>;
  }

  return (
    <div className="cemetery-container">
      <h1 className="title">Plano Cementerio</h1>
      {currentLugar && (
        <>
          <div className="cemetery-grid">
            {currentLugar.graves.map((grave) => (
              <div
                key={grave}
                className={`grave ${occupiedGraves.includes(grave) ? "occupied" : "empty"}`}
              >
                {grave}
              </div>
            ))}
          </div>

          <div className="pagination-controls">
            <button
              className="pagination-btn"
              onClick={handlePrevPage}
              disabled={currentPage === 0}
            >
              <FaAngleLeft />
            </button>

            <div className="page-buttons">
              {groupedGraves.map((group, index) => (
                <button
                  key={index}
                  className={`page-btn ${index === currentPage ? "active" : ""}`}
                  onClick={() => handlePageClick(index)}
                >
                  {group.lugareId} 
                </button>
              ))}
            </div>

            <button
              className="pagination-btn"
              onClick={handleNextPage}
              disabled={currentPage === totalPages - 1}
            >
              <FaAngleRight />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MapasTable;

*/


/*
import React, { useState, useEffect } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import axios from '../api/axios';
import "./CemeteryMap.css";

const MapasTable = () => {
  const [occupiedGraves, setOccupiedGraves] = useState([]);
  const [groupedGraves, setGroupedGraves] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    fetch("/sepulturasc")
  //axios.get("/sepulturasc")
      .then((response) => response.json())
      .then((data) => {
        const grouped = data.reduce((acc, sepultura) => {
          const { lugareId, id, clausurado, ocupado } = sepultura;
          if (!acc[lugareId]) {
            acc[lugareId] = [];
          }
          acc[lugareId].push({ id, clausurado, ocupado });
          return acc;
        }, {});

        const groupedArray = Object.keys(grouped).map(lugareId => ({
          lugareId,
          graves: grouped[lugareId]
        }));

        groupedArray.sort((a, b) => a.lugareId - b.lugareId);
        setGroupedGraves(groupedArray);
      })
      .catch((error) => console.error("Error fetching sepulturas:", error));
  }, []);

  const totalPages = groupedGraves.length;
  const currentLugar = groupedGraves[currentPage];

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (index) => {
    setCurrentPage(index);
  };

  if (totalPages === 0) {
    return <div>No hay sepulturas disponibles</div>;
  }

  return (
    <div className="cemetery-container">
      <h1 className="title">Plano Cementerio</h1>
      {currentLugar && (
        <>
          <div className="cemetery-grid">
            {currentLugar.graves.map((grave) => (
              <div
                key={grave.id}
                className={`grave ${grave.clausurado === 1 ? "clausurado" : grave.ocupado === 0 ? "available" : "occupied"}`}
              >
                {grave.id}
              </div>
            ))}
          </div>

          <div className="pagination-controls">
            <button
              className="pagination-btn"
              onClick={handlePrevPage}
              disabled={currentPage === 0}
            >
              <FaAngleLeft />
            </button>

            <div className="page-buttons">
              {groupedGraves.map((group, index) => (
                <button
                  key={index}
                  className={`page-btn ${index === currentPage ? "active" : ""}`}
                  onClick={() => handlePageClick(index)}
                >
                  {group.lugareId} 
                </button>
              ))}
            </div>

            <button
              className="pagination-btn"
              onClick={handleNextPage}
              disabled={currentPage === totalPages - 1}
            >
              <FaAngleRight />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MapasTable;
*/

/*

import React, { useState, useEffect } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import axios from '../api/axios';
import "./CemeteryMap.css";

const MapasTable = () => {
  const [occupiedGraves, setOccupiedGraves] = useState([]);
  const [groupedGraves, setGroupedGraves] = useState([]);
  const [currentPage, setCurrentPage] = useState(0); // Página actual como índice de lugarId

  useEffect(() => {
    fetch("/sepulturasc")
      .then((response) => response.json())
      .then((data) => {
        // Agrupar las sepulturas por lugarId
        const grouped = data.reduce((acc, sepultura) => {
          const { lugareId, id } = sepultura;
          if (!acc[lugareId]) {
            acc[lugareId] = [];
          }
          acc[lugareId].push(id);
          return acc;
        }, {});

        // Convertir a un array de lugares ordenados
        const groupedArray = Object.keys(grouped).map(lugareId => ({
          lugareId,
          graves: grouped[lugareId]
        }));

        // Ordenamos los lugares por lugarId
        groupedArray.sort((a, b) => a.lugareId - b.lugareId);

        setGroupedGraves(groupedArray);
      })
      .catch((error) => console.error("Error fetching sepulturas:", error));
  }, []);

  const totalPages = groupedGraves.length;
  const currentLugar = groupedGraves[currentPage];

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (index) => {
    setCurrentPage(index);
  };

  // Verifica si hay datos para mostrar
  if (totalPages === 0) {
    return <div>No hay sepulturas disponibles</div>;
  }

  return (
    <div className="cemetery-container">
      <h1 className="title">Plano Cementerio</h1>
      {currentLugar && (
        <>
          <div className="cemetery-grid">
            {currentLugar.graves.map((grave) => (
              <div
                key={grave}
                className={`grave ${occupiedGraves.includes(grave) ? "occupied" : "empty"}`}
              >
                {grave}
              </div>
            ))}
          </div>

          <div className="pagination-controls">
            <button
              className="pagination-btn"
              onClick={handlePrevPage}
              disabled={currentPage === 0}
            >
              <FaAngleLeft />
            </button>

            <div className="page-buttons">
              {groupedGraves.map((group, index) => (
                <button
                  key={index}
                  className={`page-btn ${index === currentPage ? "active" : ""}`}
                  onClick={() => handlePageClick(index)}
                >
                  {group.lugareId} 
                </button>
              ))}
            </div>

            <button
              className="pagination-btn"
              onClick={handleNextPage}
              disabled={currentPage === totalPages - 1}
            >
              <FaAngleRight />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MapasTable;
*/
